module.exports = __webpack_public_path__ + "static/kevin_kassabian-ce5d730d092dd794f324bbac91c51408.jpg";